import styled, { css } from 'styled-components';

import { mediaQuery } from '@catalyze/ui';

export const Container = styled.section`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 0 0.625rem 2rem 0.625rem;
    ${mediaQuery(
        2,
        css`
            padding: 0rem 2.375rem 2rem 3rem;
        `
    )}
`;

export const PropertyGrid = styled.div`
    display: grid;
    grid-template-columns: auto;
    grid-template-areas: 'info info' 'timeline timeline' 'edm edm';
    grid-template-rows: auto auto auto;
    column-gap: 1.875rem;
    row-gap: 0.75rem;
    margin-top: 1.5rem;
    ${mediaQuery(
        1,
        css`
            row-gap: 3rem;
        `
    )}
    ${mediaQuery(
        3,
        css`
            grid-template-areas: 'info info' 'edm timeline';
        `
    )}
`;

export const StyledNav = styled.nav`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 8rem;
`;
